import React from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Drawer,
  Typography,
  useMediaQuery,
} from "@mui/material";
import PrimaryButton from "widgets/Buttons/PrimaryButton";
import SecondaryButton from "widgets/Buttons/SecondaryButton";

const DiscardChangesDialog = ({ open, onClose, onConfirm, isLoading = false }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleConfirm = () => {
    if (isLoading) return;
    if (onConfirm) onConfirm();
  };

  const content = (
    <Box sx={{ p: 3, textAlign: "center" }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          border: "2px solid #f59e0b",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#f59e0b",
          fontWeight: 700,
          fontSize: "1.25rem",
          mx: "auto",
          mb: 2,
        }}
      >
        !
      </Box>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 1.5, fontSize: "1.2rem" }}
      >
        Discard changes?
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", mb: 3, fontSize: "0.95rem" }}
      >
        The new details will not be saved to your order.
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <PrimaryButton onClick={handleConfirm} disabled={isLoading}>
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            "Yes, keep my current order"
          )}
        </PrimaryButton>
        <SecondaryButton onClick={onClose} disabled={isLoading}>
          Cancel
        </SecondaryButton>
      </Box>
    </Box>
  );

  if (isMobile) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxWidth: 480,
            mx: "auto",
          },
        }}
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>{content}</DialogContent>
    </Dialog>
  );
};

export default DiscardChangesDialog;

